import React from 'react'
import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import clsx from 'clsx'

const colors = {
    primary: '#0057A0',
    grey: '#7d7c7c',
}

const StyledButton = styled(Button)(({ theme }) => ({
    '&.MuiButton-root': {
        borderRadius: '18.5px',
        fontFamily: 'Rubik',
        fontSize: '1.6rem',
        textAlign: 'left',
        padding: '6px 12px 0px 12px',
        border: `solid 1.40px ${colors.primary}`,

        '& .icon-img': {
            display: 'inline',
            marginLeft: '10px',
            marginRight: '12px',
        },

        '& span': {
            color: colors.primary,
            position: 'relative',
            textTransform: 'initial',
            top: '-3px',
        },

        '& img': {
            position: 'relative',
            left: '8px',
        },

        '&:hover': {
            backgroundColor: 'transparent',
        },

        '&.hover:hover': {
            backgroundColor: colors.primary,
            boxShadow: '0 5px 5px -2px rgba(48, 127, 193, 0.55)',
            color: 'white',
            '& span': {
                color: '#fff',
            },
            '& .icon-img': {
                display: 'none',
            },
            '& .icon-img-light': {
                display: 'inline',
            },
        },
    },
}))

const TextIconButton = ({ text, icon, iconActive }) => (
    <StyledButton size="medium" className={clsx(iconActive && 'hover')}>
        {text}
        <img className={'icon-img'} src={icon} alt="" aria-hidden="true" />
        {iconActive && (
            <img
                className={'icon-img-light'}
                src={iconActive}
                alt=""
                aria-hidden="true"
            />
        )}
    </StyledButton>
)

export default TextIconButton
